import store from 'utils/store/withMiddleware'
import { getVariant } from 'core/experiment'
import {
  PH_DEACTIVATE_MULTICARRIER_PLANS,
  PH_DEACTIVATE_MULTICARRIER_PLANS_VARIANTS
} from 'core/constants/experiments'
import { propAccessor } from '@hc-frontend/utils'
import storage from 'proxy-storage'

// Temporal fix to solve amplitude block issue
const defaultStates =
  'al-ar-az-de-fl-ga-ia-id-il-in-ks-ky-la-mi-mo-ms-mt-nc-nd-ne-nv-oh-ok-or-pa-sd-sc-tn-ut-va-wi-wv-wy'

export function enableMultiCarrierPlans(): boolean {
  const variant = getVariant({
    experimentKey: PH_DEACTIVATE_MULTICARRIER_PLANS,
    // fallback: PH_DEACTIVATE_MULTICARRIER_PLANS_VARIANTS.OFF
    fallback: defaultStates
  })

  // If the variant is ON, we disable multi-carrier plans
  if (variant === PH_DEACTIVATE_MULTICARRIER_PLANS_VARIANTS.ON) {
    return false
  }

  // Check if the state acronym is in the variant, so we can disable multi-carrier plans for specific states
  if (variant !== PH_DEACTIVATE_MULTICARRIER_PLANS_VARIANTS.OFF) {
    const stateAcronym =
      propAccessor(storage.getItem('hc'), 'location.state_acronym') ||
      propAccessor(store.getState(), 'hcStorage.location.state_acronym')

    if (stateAcronym && variant)
      return !variant.split('-').includes(stateAcronym.toLowerCase())
  }

  // By default, we enable multi-carrier plans to keep existing behavior
  return true
}
